import { render, staticRenderFns } from "./BusinessInformation.vue?vue&type=template&id=f865fe36&scoped=true"
import script from "./BusinessInformation.vue?vue&type=script&lang=js"
export * from "./BusinessInformation.vue?vue&type=script&lang=js"
import style0 from "./BusinessInformation.vue?vue&type=style&index=0&id=f865fe36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f865fe36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f865fe36')) {
      api.createRecord('f865fe36', component.options)
    } else {
      api.reload('f865fe36', component.options)
    }
    module.hot.accept("./BusinessInformation.vue?vue&type=template&id=f865fe36&scoped=true", function () {
      api.rerender('f865fe36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/BusinessInformation.vue"
export default component.exports